import RichText from '@/components/RichText/RichText';

interface AboutSectionProps {
    title?: string;
    description?: string;
}

const AboutSection = ({title, description}: AboutSectionProps) => {
    if (!title && !description) return null;

    return (
        <div className='my-8 flex w-full flex-col items-center gap-4 text-left'>
            <RichText as='h2' html={title} variant='subsectionTitle' className='w-full text-left' />
            <RichText as='p' html={description} />
        </div>
    );
};

export default AboutSection;
